import _ from 'lodash';
import { CountertopLine, CountertopMaterial, CountertopPanel, CountertopPanelsJoint } from '../countertop.interface';
import { CountertopUtils } from '../countertop.utils';
import { GShapedCountertopPanel } from './g-shaped-countertop-panel';

export interface GShapedCountertopLineOptions {
  panels: GShapedCountertopPanel[];
  isVertical: boolean;
}

export interface GShapedCountertopPanelsJoint extends CountertopPanelsJoint {
  panel1: GShapedCountertopPanel;
  panel2: GShapedCountertopPanel;
}

export class GShapedCountertopLine implements CountertopLine {
  uid: string = crypto.randomUUID();
  _material: CountertopMaterial;
  panels: CountertopPanel[] = [];
  isVertical: boolean;
  panelsJoints: GShapedCountertopPanelsJoint[];

  /**
   * Создает линию с панелями
   * @param length
   * @param width
   * @param material
   * @param options
   */
  constructor(
    length: number,
    width: number,
    material: CountertopMaterial,
    options?: Partial<GShapedCountertopLineOptions>
  ) {
    if (!options?.panels?.length) {
      const panelsCount = Math.ceil(length / material.height);
      const panelLength = length / panelsCount;
      _.times(panelsCount).forEach(() => {
        this.panels.push(new GShapedCountertopPanel(panelLength, width));
      });
    } else {
      this.panels = options.panels;
    }

    this.material = material;

    this.width = width;
    this.length = length;

    this.panelsJoints = [];
    this.isVertical = options.isVertical;
  }

  get material(): CountertopMaterial {
    return this._material;
  }
  set material(value: CountertopMaterial) {
    CountertopUtils.checkLineWidth(this.width, value);

    this._material = value;
  }

  get length(): number {
    return this.panels.reduce((acc, l) => acc + l.length, 0);
  }
  set length(value: number) {
    CountertopUtils.setLineLength(value, this, (l, w) => new GShapedCountertopPanel(l, w));
  }
  get width(): number {
    return this.panels[0].width;
  }
  set width(value: number) {
    this.panels.forEach(p => (p.width = value));
  }

  addPanel(height = 0, panelId?: string, direction: 'after' | 'before' = 'after'): GShapedCountertopPanel {
    const panel = new GShapedCountertopPanel(height, this.width);

    const getInsertIndex = (): number =>
      this.panels.findIndex(p => p.uid === panelId) + (direction === 'before' ? 0 : 1);

    const index = panelId ? getInsertIndex() : direction === 'before' ? 0 : this.panels.length;

    this.panels.splice(index, 0, panel);

    return panel;
  }
}
